import React, { Component } from 'react';
import { Modal } from 'antd';

import { CloseIcon } from '../../icons';

import './AirModalTitlebar.css';

export default class AirModalTitlebar extends Component {
  render() {
    return (
      <Modal
        closable={false}
        footer={false}
        className={`AirModalTitlebar ${this.props.className || ''}`}
        centered={true}
        onCancel={this.props.onCancel}
        visible={this.props.visible}
        width={this.props.width}
      >
        <div className="title" style={this.props.titlebarStyle}>{this.props.title}</div>
        <div className="close">
          <CloseIcon onClick={this.props.onCancel} style={this.props.titlebarStyle} />
        </div>
        <div className="content">{this.props.children}</div>
        <div className="buttons" style={{...!!this.props.cancelButton && !!this.props.okButton ? { justifyContent: 'space-between' } : { justifyContent: 'flex-end' }, ...this.props.buttonsStyle}}>
          {!!this.props.cancelButton && (
            <div className="cancelButton" onClick={this.props.onClickCancel || this.props.onCancel}>
              {this.props.cancelButton}
            </div>
          )}
          {!!this.props.okButton && (
            <div className="okButton" onClick={this.props.onOk}>
              {this.props.okButton}
            </div>
          )}
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/AirModalTitlebar/AirModalTitlebar.js